import React, { useEffect, useState } from "react";
import axios from "axios";

const CaseInfoPage = () => {
  const [tableData, setTableData] = useState([]);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [eventTitle, setEventTitle] = useState("");
  const [eventComments, setEventComments] = useState("");
  const [eventFile, setEventFile] = useState(null);

  useEffect(() => {
    const id = localStorage.getItem("selectedCaseId");
    const token = localStorage.getItem("token");
    axios
      .get(
        `https://admindashboard.clns.in/api/dashboard/case_info/get/${id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        console.log(response, "response");
        setTableData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Handle the file input change
  const handleFileChange = (e) => {
    setEventFile(e.target.files[0]);
  };

  // Handle the form submission
  const handleAddEvent = (e) => {
    e.preventDefault();
    const caseId = localStorage.getItem("selectedCaseId");

    // Prepare form data
    const formData = new FormData();
    formData.append("case_id", caseId);
    formData.append("event_name", eventTitle);
    formData.append("comments", eventComments);
    formData.append("documents", eventFile);

    // Send the POST request
    const token = localStorage.getItem("token");
    axios
      .post("https://admindashboard.clns.in/api/adv-client/case/events/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log("Event added successfully", response);
        // Reset the form
        setEventTitle("");
        setEventComments("");
        setEventFile(null);
        setIsFormVisible(false); // Hide the form after submission
      })
      .catch((error) => {
        console.error("Error adding event:", error);
      });
  };

  const renderCaseInfo = () => {
    return (
      <>
        <div
          className="case-info-page"
          style={{
            fontFamily: "Arial, sans-serif",
            fontSize: "14px",
            color: "#333",
            padding: "24px",
            backgroundColor: "#f7f7f7",
            border: "1px solid #e5e5e5",
            borderRadius: "8px",
          }}
        >
          <div
            className="case-header"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "24px",
            }}
          >
            <div className="case-id" style={{ fontWeight: "bold" }}>
              <span>Case ID:</span>
              <span>{tableData?.case_details?.case_id}</span>
            </div>
            <div className="case-status" style={{ color: "#4CAF50" }}>
              <span>Status:</span>
              <span>{tableData?.case_details?.case_status}</span>
            </div>
            <div className="case-created-date">
              <span>Created on:</span>
              <span>{formatDate(tableData?.case_details?.created_at)}</span>
            </div>
          </div>

          {/* Add Event Button */}
          <div
            className="add-event-button"
            style={{
              marginBottom: "16px",
              textAlign: "center",
            }}
          >
            <button
              onClick={() => setIsFormVisible((prev) => !prev)}
              style={{
                backgroundColor: "#007bff",
                color: "#fff",
                padding: "8px 16px",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              {isFormVisible ? "Cancel" : "Add Event"}
            </button>
          </div>

          {/* Add Event Form */}
          {isFormVisible && (
            <form onSubmit={handleAddEvent} style={{ marginBottom: "24px" }}>
              <div
                className="form-group"
                style={{
                  marginBottom: "12px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label>Event Title:</label>
                <input
                  type="text"
                  value={eventTitle}
                  onChange={(e) => setEventTitle(e.target.value)}
                  required
                  style={{
                    padding: "8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
              <div
                className="form-group"
                style={{
                  marginBottom: "12px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label>Comments:</label>
                <textarea
                  value={eventComments}
                  onChange={(e) => setEventComments(e.target.value)}
                  required
                  style={{
                    padding: "8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    resize: "vertical",
                  }}
                />
              </div>
              <div
                className="form-group"
                style={{
                  marginBottom: "12px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <label>Document:</label>
                <input
                  type="file"
                  onChange={handleFileChange}
                  required
                  style={{
                    padding: "8px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
              <div
                className="form-actions"
                style={{
                  textAlign: "center",
                  marginTop: "16px",
                }}
              >
                <button
                  type="submit"
                  style={{
                    backgroundColor: "#28a745",
                    color: "#fff",
                    padding: "8px 16px",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Submit Event
                </button>
              </div>
            </form>
          )}

          {/* Existing Case Information */}
          {/* Your existing case-related information, events, documents, and timeline goes here */}

          {/* Case Summary */}
          <div
            className="case-summary"
            style={{
              marginBottom: "24px",
              padding: "12px",
              backgroundColor: "#fff",
              borderRadius: "4px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h3
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Summary
            </h3>
            <p>
              {tableData?.case_details?.case_summary === null
                ? "No data"
                : tableData?.case_details?.case_summary}
            </p>
          </div>

          {/* Case Statement */}
          <div
            className="case-statement"
            style={{
              marginBottom: "24px",
              padding: "12px",
              backgroundColor: "#fff",
              borderRadius: "4px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h3
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Statement
            </h3>
            <p>
              {tableData?.case_details?.case_description === null
                ? "No data"
                : tableData?.case_details?.case_description}
            </p>
          </div>

          {/* Case Documents */}
          <div
            className="case-documents"
            style={{
              marginBottom: "24px",
              padding: "12px",
              backgroundColor: "#fff",
              borderRadius: "4px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h3
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              All Documents
            </h3>
            <div
              className="documents-list"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              {tableData?.events_list?.map((event) => (
                <div
                  key={event.id}
                  className="document-item"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 12px",
                    borderRadius: "4px",
                    backgroundColor: "#f7f7f7",
                  }}
                >
                  <div className="document-name">{event.event_name}</div>
                  <div className="document-date">
                    {formatDate(event.uploaded_on)}
                  </div>
                  <div className="document-actions">
                    <a
                      href={event.documents}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Document
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Timeline */}
          <div
            className="case-timeline"
            style={{
              marginBottom: "24px",
              padding: "12px",
              backgroundColor: "#fff",
              borderRadius: "4px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h3
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                marginBottom: "8px",
              }}
            >
              Timeline
            </h3>
            {tableData?.advocate_events_list?.map((event) => (
              <div
                key={event.id}
                className="timeline-item"
                style={{
                  marginBottom: "12px",
                  padding: "8px",
                  backgroundColor: "#f7f7f7",
                  borderRadius: "4px",
                }}
              >
                <div className="timeline-date">
                  {formatDate(event.uploaded_on)}
                </div>
                <div className="timeline-event">{event.event_name}</div>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  };

  return <div>{renderCaseInfo()}</div>;
};

export default CaseInfoPage;
